/**
  This component use in listing of content.
*/
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-media-thumbnail',
  templateUrl: './media-thumbnail.component.html',
  styleUrls: ['./media-thumbnail.component.scss']
})
export class MediaThumbnailComponent implements OnInit {

  @Input() media: { [key: string]: any };
  imageURL: string;
  constructor() { }

  ngOnInit() {    
    switch (this.media.contentType) {
      case "VIDEO":
      case "IMAGE":
        this.imageURL = this.media.thumbnailUrl || this.media.media || null;
        break;

      default:
        break;
    }

    // console.log('MediaThumbnailComponent > ngOnInit > media > ', this.media);
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/shared/components/media-thumbnail/media-thumbnail.component.ts